export enum CCodeRotation {
  /**
   * 旋转0度
   */
  ROTATION_0 = 'B',
  /**
   * 旋转90度
   */
  ROTATION_90 = 'VB',
}
